import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/apply-user/login",
    method: "post",
    params: data
  });
}
